import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityAlert } from "../../entity/EntityAlert";

export class DtoAlertsGetReq extends EntityAlert {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_alert_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
